export enum AlertStatus {
    Error = 'error',
    Warning = 'warning',
    Success = 'success',
    Info = 'info'
}

export interface AlertProps {
    status: AlertStatus;
    children: React.ReactNode;
}